export default function TaskActionsMenu({
  task,
  isSelected,
  onToggleSelection,
  onCopyTitle,
  onPrint,
  onEdit,
  onDelete,
  onClose,
}) {
  return (
    <div className="task-menu" onClick={(event) => event.stopPropagation()}>
      <label className="task-select-checkbox task-menu-checkbox" title="Sélectionner la tâche">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => onToggleSelection(task.id)}
        />
        <span className="task-select-checkmark" />
      </label>

      <button
        type="button"
        className="task-copy-btn task-menu-btn"
        title="Copier le titre"
        onClick={(event) => {
          event.stopPropagation();
          onCopyTitle(task);
        }}
      >
        ⧉
      </button>

      <button
        type="button"
        className="print-btn task-menu-btn"
        title="Imprimer la tâche"
        onClick={(event) => {
          event.stopPropagation();
          onClose();
          onPrint(task);
        }}
      >
        🖨️
      </button>

      <button
        type="button"
        className="edit-btn task-menu-btn"
        title="Modifier la tâche"
        onClick={(event) => {
          event.stopPropagation();
          onClose();
          onEdit(task);
        }}
      >
        ✏️
      </button>

      <button
        type="button"
        className="delete-btn task-menu-btn"
        title="Supprimer la tâche"
        onClick={(event) => {
          event.stopPropagation();
          onClose();
          onDelete(task.id);
        }}
      >
        🗑
      </button>
    </div>
  );
}
